import { getCookie, setSecureCookie, getCookieDomain } from '../../utils/secureCookies';

const DOMAIN = getCookieDomain();

const BROWSER_SESSION_ID = 'browser_session_id';
const SEGMENT_ANONYMOUS_ID = 'ajs_anonymous_id';

export const getBrowserSessionId = () => {
  try {
    let browserSessionId = getCookie(BROWSER_SESSION_ID);
    if (!browserSessionId) {
      let id = localStorage.getItem(BROWSER_SESSION_ID) ?? getCookie(SEGMENT_ANONYMOUS_ID);
      if (!id && window.crypto) {
        id = crypto.randomUUID();
      }
      browserSessionId = id as string;
      // Set secure cookie for browser session ID with session expiry
      setSecureCookie(BROWSER_SESSION_ID, browserSessionId, {
        domain: DOMAIN,
        // Session cookie - expires when browser closes
        expires: undefined,
      });
      localStorage.setItem(BROWSER_SESSION_ID, browserSessionId);
    }
    return browserSessionId;
  } catch {
    return 'N/A';
  }
};
